import React from 'react'
import NextImage from 'next/image'

import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text'

import { EmptyStateWithAction } from 'app/ProfileRevampPage/components/EmptyState'
import ListItem from 'app/ProfileRevampPage/components/SectionKarya/PerangkatAjar/ListItem'
import { TXT_DEFAULT_NO_PERANGKAT_AJAR } from 'app/ProfileRevampPage/constants'
import { useProfile } from 'app/ProfileRevampPage/hooks/useProfile'
import { useLayoutState } from 'app/ProfileRevampPage/hooks/useLayoutState'
import { useSETrackEvent } from 'app/ProfileRevampPage/hooks/useSETrackEvent'

const PerangkatAjarSection = (props: React.HTMLAttributes<HTMLDivElement>) => {
  const { isCurrentUser, profileId, profileData } = useProfile()
  const { hasPerangkatAjar } = useLayoutState()
  const { SETrackClickEmptyStateToolkit } = useSETrackEvent()

  return (
    <div className="px-4 py-6" {...props}>
      <div className="flex space-x-2 items-center mb-3">
        <NextImage
          layout="fixed"
          src="/icon/menu-perangkat-ajar.svg"
          alt="Perangkat Ajar"
          width="24px"
          height="24px"
        />
        <Text variant="heading-md">Perangkat Ajar</Text>
      </div>

      {hasPerangkatAjar ? (
        <div>
          {(profileData?.toolkits ?? []).map(({ type, count = 0 }) => {
            // hide empty Category when viewed by other than current user (self)
            if (!isCurrentUser && count === 0) {
              return null
            }

            return (
              <div key={`profile-toolkit-${type.toLowerCase()}`}>
                <ListItem
                  data-testid="profile-perangkat-ajar-list-item"
                  type={type}
                  subtitle={
                    !!Number(count)
                      ? `${count} karya`
                      : TXT_DEFAULT_NO_PERANGKAT_AJAR
                  }
                  href={`/profil/${profileId}/perangkat-ajar/${type}/`}
                />
                <Separator />
              </div>
            )
          })}
        </div>
      ) : (
        <EmptyStateWithAction
          description="Punya Perangkat Ajar untuk ditampilkan di sini?"
          actionText="Tentang kontribusi Perangkat Ajar"
          actionPath="https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/7322610568473-Menjadi-Kontributor-Perangkat-Ajar"
          className="p-3 bg-surface-neutral-subdued rounded-[4px]"
          onActionButtonClicked={SETrackClickEmptyStateToolkit}
        />
      )}
    </div>
  )
}

export default PerangkatAjarSection
